module.exports = __webpack_public_path__ + "img/sqlquery.46b46067.png";